import { BlockDefinition } from "@softr-io/blocks-sdk";
import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "block-definition-storage";

export const useDefinitionStorage = (runtimeDefinition: BlockDefinition, originalDefinition: BlockDefinition) => {
    const [isUsingStorageDefinition, setIsUsingStorageDefinition] = useState(false);
    const [currentDefinition, setCurrentDefinition] = useState<BlockDefinition>(runtimeDefinition);

    useEffect(() => {
        const storedDefinition = localStorage.getItem(STORAGE_KEY);
        if (storedDefinition) {
            try {
                const parsedDefinition = JSON.parse(storedDefinition);
                setCurrentDefinition(parsedDefinition);
                setIsUsingStorageDefinition(true);
            } catch (error) {
                console.error("Failed to parse stored definition:", error);
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    }, []);

    const setStorageDefinition = useCallback((definition: BlockDefinition) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(definition));
            setCurrentDefinition(definition);
            setIsUsingStorageDefinition(true);
        } catch (error) {
            console.error("Failed to store definition:", error);
        }
    }, []);

    const clearStorageDefinition = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setCurrentDefinition(originalDefinition);
        setIsUsingStorageDefinition(false);
    }, [originalDefinition]);

    return {
        currentDefinition,
        isUsingStorageDefinition,
        setStorageDefinition,
        clearStorageDefinition,
    };
};
